<template>
	<div class="supply-shortage">
		<p class="supply-shortage__text">
			<span>Note:</span> Due to supply issues, we may not have all PC components in stock. In that case, we will automatically swap the component for an equivalent or upgraded item at no extra cost. If you have any questions, please reach out to Customer Support.
		</p>

		<promo-sales-timed>
			<template>
				<p class="supply-shortage__text supply-shortage__text--cancel-order">
					Please note: Prebuild orders cannot be canceled during Holiday Celebration.
				</p>
			</template>
		</promo-sales-timed>
	</div>
</template>

<script>
import PromoSalesTimed from "@/components/promo-sales-timed";

export default {
	name: "SupplyShortageNote",
	components: {
		PromoSalesTimed
	}
};
</script>

<style lang="scss" scoped>
.supply-shortage {
	border: 1px solid #8D29A0;
	border-radius: 1px;
	padding: 11px 20px;
	max-width: 620px;
	margin-bottom: 30px;

	@media (min-width: 991px) {
		margin-left: 13.733333%;
		padding: 10px 15px;
	}

	&__text {
		color: #5F707F;
		line-height: 21px;
		margin: 0;
	}

	&__text--cancel-order {
		margin-top: 15px;
	}

	span {
		color: #8D29A0;
		font-weight: bold;
	}
}
</style>